import React from 'react';
import PropTypes from 'prop-types';

import {
  AssignmentsGradesColumn,
  Container,
  Column,
  Header,
  HeaderRight,
  Separator,
} from './StudentsTable.styled';
import StudentInfoColumn from '../StudentsInfoColumn';
import AssignmentsColumn from '../AssignmentsColumn';
import ExportGradesColumn from '../ExportGradesColumn';
import { studentGradesType } from '../../types';

const StudentsTable = ({
  studentGrades,
  assignments,
  updateStudentOverride,
  launchTurnitinAssignment,
  hasGradeOverride,
}) => (
  <Container>
    <Column>
      <Header>Student</Header>
      <Separator />
      <StudentInfoColumn studentGrades={studentGrades} />
    </Column>
    <AssignmentsGradesColumn totalAssignments={assignments.length}>
      <AssignmentsColumn
        studentGrades={studentGrades}
        assignments={assignments}
        launchTurnitinAssignment={launchTurnitinAssignment}
      />
    </AssignmentsGradesColumn>
    <Column>
      <HeaderRight>Grade to export</HeaderRight>
      <ExportGradesColumn
        studentGrades={studentGrades}
        updateStudentOverride={updateStudentOverride}
        hasGradeOverride={hasGradeOverride}
      />
    </Column>
  </Container>
);

StudentsTable.propTypes = {
  studentGrades: PropTypes.arrayOf(studentGradesType).isRequired,
  assignments: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    })
  ).isRequired,
  updateStudentOverride: PropTypes.func.isRequired,
  launchTurnitinAssignment: PropTypes.func.isRequired,
  hasGradeOverride: PropTypes.bool.isRequired,
};

export default StudentsTable;
